module.exports = __webpack_public_path__ + "static/img/Pumpkin.d9f6f40b.png";